import React from 'react';
import { UserIcon } from '@heroicons/react/24/outline';

function UserMenuHeader({ userName = '', userEmail = '' }) {
  const displayEmail = userEmail || userName || 'usuário@marketingpro.app';

  return (
    <div className="mp-user-menu__header">
      <p className="mp-user-menu__label">Conectado como</p>

      <div className="mp-user-menu__identity">
        <div className="mp-user-menu__avatar-shell" aria-hidden="true">
          <UserIcon className="mp-user-menu__avatar-icon" />
        </div>

        <p className="mp-user-menu__email">
          {displayEmail}
        </p>
      </div>
    </div>
  );
}

export default UserMenuHeader;